import { render, staticRenderFns } from "./CreationDiagnostics.vue?vue&type=template&id=af4f004e&scoped=true"
import script from "./CreationDiagnostics.vue?vue&type=script&lang=js"
export * from "./CreationDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./CreationDiagnostics.vue?vue&type=style&index=0&id=af4f004e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4f004e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4f004e')) {
      api.createRecord('af4f004e', component.options)
    } else {
      api.reload('af4f004e', component.options)
    }
    module.hot.accept("./CreationDiagnostics.vue?vue&type=template&id=af4f004e&scoped=true", function () {
      api.rerender('af4f004e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CreationDiagnostics.vue"
export default component.exports